export var OPTION_CLASS = "recorder__toolbar-option";
export var OPTION_CENTER = "recorder__toolbar-center";
export var FRAMES_BUTTON = OPTION_CLASS + "--frames";
export var COLOR_PICKER = OPTION_CLASS + "--color";
export var SIZE_PICKER = OPTION_CLASS + "--size";
export var SPEED_PICKER = OPTION_CLASS + "--speed";
export var LABEL = OPTION_CLASS + "-label";
export var BUTTON = "button " + OPTION_CLASS + "-button";
export var ICON_BUTTON = "button " + OPTION_CLASS + "-icon-button";
export var CONTROL_CLASS = "recorder__toolbar-control";
export var RECORD_BUTTON = CONTROL_CLASS + "--record";
export var STOP_RECORD_BUTTON = CONTROL_CLASS + "--stop";